import { PartyTierDto } from '../../../config/finance/financeConfig'
import * as React from 'react'
import { ReactElement } from 'react'
import { baseListStyles } from '../../List/BaseList'
import useCurrency from '../../../hooks/useCurrency'
import MoneyText from '../../Text/Currency/MoneyText'
import { useTranslation } from 'react-i18next'
import { formatFullNumericDate } from '../../../helpers/dateHelper'
import { Badge, makeStyles, mergeClasses, tokens } from '@fluentui/react-components'
import { MoneyRegular } from '@fluentui/react-icons'

const useItemStyles = makeStyles({
    listTaskItem: {
        display: 'grid',
        gap: tokens.spacingVerticalS,
        gridTemplateColumns: '1fr 5fr',
        gridTemplateRows: '1fr 1fr',
    },
    gap: {
        display: 'flex',
        gap: tokens.spacingVerticalS,
    },
})

export type PartyTierListItemProps = {
    index: number
    item: PartyTierDto
    editTier: (index: number) => void
}

export function PartyTierListItem(props: PartyTierListItemProps): ReactElement {
    const { t: translate } = useTranslation()
    const styles = useItemStyles()
    const { currency } = useCurrency(props.item.currency)

    return (
        <div
            className={mergeClasses(baseListStyles.itemCell, styles.listTaskItem)}
            onClick={() => props.editTier(props.index)}
        >
            <div>{translate('party.edit.tier.date')}:</div>
            <div className={styles.gap}>
                <Badge size="medium" appearance="tint">
                    {formatFullNumericDate(props.item.validFrom)}
                </Badge>
                <Badge size="medium" appearance="tint">
                    {formatFullNumericDate(props.item.validTo)}
                </Badge>
            </div>
            <div>{translate('party.edit.tier.salesrate')}:</div>
            <div>
                <Badge size="medium" icon={<MoneyRegular />} appearance="tint">
                    <MoneyText amount={props.item.salesRate} currency={currency} />
                </Badge>
            </div>
        </div>
    )
}
